<app-project-submenu></app-project-submenu>

<p-confirmDialog></p-confirmDialog>
<p-menu
  #messageMenu
  [model]="this.activeMenuItems"
  [popup]="true"
  appendTo="body"
></p-menu>

<div class="d-flex align-items-center gap-3 mt-3 mb-3">
  <p-button
    icon="ri-arrow-left-line"
    severity="secondary"
    [rounded]="true"
    (onClick)="goBack()"
  ></p-button>
  <h4 class="mb-0">{{ channel }}</h4>
</div>

<div
  #chatContainer
  class="chat-container"
  >
  @for (msg of messages; track msg; let i = $index) {
    <div
      [attr.data-msg-index]="i"
      class="mb-3 p-2"
      >
      <div class="d-flex justify-content-between align-items-center mb-1">
        <div class="d-flex align-items-center gap-2">
          <strong>{{ msg.botName }}</strong>
          @if (msg.isEdited) {
            <small
              class="text-muted"
              i18n="@@message-edited"
            >(bearbeitet)</small>
          }
        </div>
        <div class="d-flex align-items-center gap-2">
          <small class="text-muted">{{ msg.timestamp | date:'dd.MM.yyyy HH:mm:ss' }}</small>
          <p-button
            icon="ri-more-2-fill"
            severity="secondary"
            [rounded]="true"
            [text]="true"
            size="small"
            (onClick)="openMessageMenu($event, msg)"
          ></p-button>
        </div>
      </div>
      <div>{{ msg.message }}</div>
    </div>
  }

  @if (messages.length === 0) {
    <div
      class="text-center text-muted p-5"
      i18n="@@no-chat-messages"
      >
    Keine Nachrichten in diesem Kanal.
  </div>
  }
</div>

<p-dialog
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="showEditDialog"
  i18n-header="@@edit-message-header"
  header="Nachricht bearbeiten"
  [style]="{ width: '500px' }"
  >
  @if (editingMessage) {
    <div
      class="mb-3"
      >
      <span class="d-block mb-1 text-muted">{{ editingMessage.botName }}</span>
      <input
        pInputText
        [(ngModel)]="editMessageText"
        fluid
        >
    </div>
  }
  <ng-template #footer>
    <p-button
      severity="secondary"
      i18n-label="@@cancel"
      label="Abbrechen"
      (onClick)="cancelEditMessage()"
    ></p-button>
    <p-button
      i18n-label="@@save"
      label="Speichern"
      (onClick)="saveEditMessage()"
    ></p-button>
  </ng-template>
</p-dialog>
